module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-3-50.80249ed0.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-3-50.png
// module id = 2557
// module chunks = 11